import React from 'react';
import { useBlogPosts } from '../hooks/useAirtable';
import BlogCard from '../components/common/BlogCard';
import '../styles/blog.css';

const Blog = () => {
  const { data: posts, loading, error } = useBlogPosts();

  if (loading) return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Loading blog posts...</p>
    </div>
  );

  if (error) return (
    <div className="error-state">
      <h2>Unable to load posts</h2>
      <p>{error}</p>
    </div>
  );

  return (
    <div className="blog">
      <section className="page-hero" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/images/hero/hero-background.jpg'})`, backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <h1 className="page-title">Blog & Stories</h1>
          <p className="page-subtitle">
            Insights from our community and updates from rural talent hubs
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {posts && posts.length > 0 ? (
            <div className="blog-grid">
              {posts.map((post) => (
                <BlogCard key={post.id} post={post} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <h3>No blog posts yet</h3>
              <p>Check back soon for updates from our community!</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;